export default "__VITE_ASSET__B_UW8Q39__"